'use strict';

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var beautify = require('js-beautify').js_beautify;
var tags = require('./tags');

function convert(str) {
	var proxy = document.createElement('div');
	proxy.innerHTML = str;
	var alkaliDOM = toAlkali(proxy.children[0]);
	return beautify(alkaliDOM);
}

function bindArguments(js) {
	// TODO: use jscodeshift for this
	if (!js.match(/\w+\(.*\)/)) return js;
	var name = js.match(/(\w+)\s?\(/)[1];
	var args = js.match(/\((.*)\)/)[1].split(',').map(function (s) {
		return s.trim();
	});
	var bindArgs = ['window'].concat(args).filter(Boolean).join(', ');
	return name + '.bind(' + bindArgs + ')';
}

function mountJSON(obj) {
	var body = Object.keys(obj).reduce(function (arr, key) {
		var val = '"' + obj[key] + '"'; // quoted string, default
		if (key == 'attributes') val = '' + mountJSON(obj[key]); // nested object
		else if (key.indexOf('on') == 0) val = val.slice(1, -1); // unquoted strin
		return arr.concat('"' + key + '": ' + val);
	}, []);
	return '{' + body.join(', ') + '}';
}

function handleTextNode(el) {
	var txt = el.textContent;
	var isEmpty = txt.split(/[\s\n\t\r]*/).filter(Boolean).length == 0;
	if (isEmpty) return null;
	return '\'' + txt + '\'';
}

function toAlkali(el) {

	if (el.nodeType == 3) return handleTextNode(el);

	var tag = tags[el.tagName];
	var id = el.id ? '#' + el.id : '';
	var classes = [].concat(_toConsumableArray(el.classList)).map(function (clss) {
		return '.' + clss;
	}).join('');

	var attributes = [].concat(_toConsumableArray(el.attributes)).reduce(function (obj, attr) {
		if (['id', 'class', 'children'].indexOf(attr.name) != -1) return obj;
		if (attr.name.indexOf('on') == 0) obj[attr.name] = bindArguments(attr.value);else if (typeof el[attr.name] == 'undefined') {
			if (!obj.attributes) obj.attributes = {};
			obj.attributes[attr.name] = attr.value;
		} else obj[attr.name] = attr.value;
		return obj;
	}, {});

	var children = [].concat(_toConsumableArray(el.childNodes)).map(toAlkali).filter(Boolean);
	var selector = id + classes;
	var args = [];

	if (selector) args.push('\'' + selector + '\'');
	if (el.textContent && children.length == 0) children.unshift('\'' + el.textContent + '\'');
	if (children.length > 0) args.push('[\n' + children.join(',\n') + '\n]');
	if (Object.keys(attributes).length > 0) args.push(mountJSON(attributes));

	return tag + '(' + args.join(', ') + ')';
}

module.exports = convert;


//////////////////
// WEBPACK FOOTER
// ./src/index.js
// module id = 2
// module chunks = 0